import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './MFActivities.css';
import Pagination from '../../CommonUI/Pagination/Pagination';
import { format, parseISO } from 'date-fns';
import MarketMF from "../MarketMF";
import { Vortex } from 'react-loader-spinner'

function MFActivities() {
    const [data, setData] = useState([]);

    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [loadingshow, setloadingshow] = useState(false);
    
    const { BaseURL } = useContext(URLstateContext);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;


    useEffect(() => {
        setloadingshow(true);
        window.scrollTo(0, 0)
        const getUrl = BaseURL + "MFActivites";
        fetch(`${getUrl}/10`)
            .then((response) => response.json())
            .then((data) => {
                getData = data.data;
                setData(getData);
                setloadingshow(false);
                // console.log(getData, "getData")
            })
            .catch((error) => {
            });


    }, []);



    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);

    return (
        <>
            <div class="col-12 p-0 breadcrumMF ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/mutual-funds">Mutual Fund</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Mutual Fund Activities</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='Fund-loser-sc'>
                            <div className='Fund-header'>
                                <h2><span>MF Activities</span></h2>
                            </div>
                            <MarketMF optionValue="Mutual Fund Activities" />







                            {/* <hr></hr> */}
                            <div className='Fund-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th className='text-left' >Reporting Date</th>
                                            <th className='text-right' >Equity / Debt</th>
                                            <th className='text-right' >Gross Purchase(Rs Cr.)</th>
                                            <th className='text-right' >Gross Sale(Rs Cr.)</th>
                                            <th className='text-right' >Net Purchase(Rs Cr.)</th>



                                        </tr>

                                    </thead>

                                    <tbody>
                                        {currentTableData && currentTableData.map(
                                            ({ TRANS_DATE, EQ_GR_PURC, EQ_GR_SALE, EQ_G_NE_PS, DE_GR_PURC, DE_GR_SALE, DB_G_NE_PS }) => (
                                                <>


                                                    <tr>
                                                        <td className="text-left"> {(TRANS_DATE != null) ? format(parseISO(TRANS_DATE), 'dd-MMM-yyyy') : 0}</td>
                                                        <td className="text-right"> Equity</td>
                                                        <td className="text-right">{EQ_GR_PURC}</td>
                                                        <td className="text-right">{EQ_GR_SALE}</td>

                                                        <td><div className={EQ_G_NE_PS.toFixed(2) > 0 ? "textGreen text-right" : "textRed text-right"}> {EQ_G_NE_PS != null ? EQ_G_NE_PS.toFixed(2) : 0} </div></td>

                                                    </tr>


                                                    <tr>
                                                        <td></td>
                                                        <td className="text-right">Debt</td>
                                                        <td className="text-right">{DE_GR_PURC}</td>
                                                        <td className="text-right">{DE_GR_SALE}</td>

                                                        <td><div className={DB_G_NE_PS.toFixed(2) > 0 ? "textGreen text-right" : "textRed text-right"}> {DB_G_NE_PS != null ? DB_G_NE_PS.toFixed(2) : 0} </div></td>

                                                    </tr>

                                                </>
                                            )
                                        )}
                                    </tbody>
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default MFActivities;






